import type React from 'react';

import { usePushDeviceSync } from '../../hooks/push/usePushDeviceSync';
import { useServiceWorkerMessages } from '../../hooks/push/useServiceWorkerMessages';

export const PushBridge: React.FC = () => {
  usePushDeviceSync();
  useServiceWorkerMessages();
  return null;
};
